import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CONFIG from '../../../config';
import Header from '../Header';
import Button from '../Button/button';

const ErrorDiv = styled.div`
  position: relative;
  height: 100vh;
`;

const TextDiv = styled.h1`
  text-align: center;
  position: relative;
  top: 22%;
`;

const BrokenText = styled.h2`
  text-align: center;
  position: relative;
  top: 22%;
  color: gray;
  font-size: 18px !important;
  padding-left: 5px;
  padding-right: 5px;
  @media (min-width: 768px) {
    font-size: 20px !important;
  }
  @media (min-width: 1200px) {
    font-size: 22px !important;
  }
`;

const goBack = () => {
  window.history.go(-1);
};

const ErrorPage = () => {
  const cloudFront = CONFIG.cloudFront;
  const [scrolling, setScrolling] = useState(false);

  const handleScroll = () => {
    setScrolling(true);
    let top = window.scrollY <= 0;
    if (top === true) {
      setScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ErrorDiv>
      <Header fixed={true} isScrolling={scrolling} />
      <TextDiv>Oops!</TextDiv>
      <BrokenText>Something went wrong. We are experiencing technical issues and our team on it.</BrokenText>
      <BrokenText>
        Still facing issue? Mail us the details to{' '}
        <a className="headingFont weight-500 ghostLink" href="mailto:support@log2base2.com">
          support@log2base2.com
        </a>
      </BrokenText>
      <Button onClick={goBack} primary style={{ display: 'block', margin: '0 auto', position: 'relative', top: '25%' }}>
        Go Back
      </Button>
    </ErrorDiv>
  );
};

export default ErrorPage;
